import { SET_PUBLISHER_ID } from "../../../constants/types";

const initialState = {
  publisherId: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_PUBLISHER_ID:
      return {
        ...state,
        publisherId: payload,
      };
    default:
      return state;
  }
}
